function Modal2(){
    return(
        <div>
            모달테스트2
        </div>
    );
}
export default Modal2;